import { Component, OnInit, ViewChild, ElementRef, Renderer2  } from '@angular/core';
import { Subscription } from 'rxjs';
import { CanvasStateService } from 'src/app/service/canvas-state.service';
import { ScaleService } from 'src/app/service/scale.service';
import { CanvasState } from 'src/app/model/canvas-state';
import { Point } from 'src/app/model/point';
import { SCALE } from 'src/app/data/scale';
import * as $ from 'jquery';
import { CANVAS_OPTIONS } from 'src/app/data/canvas-options';
import { CanvasOptionsService } from 'src/app/service/canvas-options.service';
import { isArray } from 'util';
import { OptionsService } from 'src/app/service/options.service';
import { ElementsService } from 'src/app/service/elements.service';
import { DataService } from 'src/app/service/data.service';
import { HEADER_OFFSET } from '@angular/core/src/render3/interfaces/view';
import { UndoService } from 'src/app/service/undo.service';

declare var require: any
@Component({
  selector: 'app-canvas',
  template: `
  <div class="mmc-canvas-wrapper" id="mmcCanvasWrapper" #mmcCanvasWrapper (window:resize)="resize()">
    <canvas class="mmc-canvas-main" id="mmcCanvasMain" #mmcCanvasMain style='width:"100%"; height:"100%"'     
    >
    </canvas>
  </div>
  `,
  styleUrls: ['./canvas.component.less']
})
export class CanvasComponent implements OnInit {

    subscription: Subscription;

    @ViewChild('mmcCanvasMain') canvasRef: ElementRef;
    @ViewChild('mmcCanvasWrapper') canvasWrapper: ElementRef;
    @ViewChild('map') map: ElementRef;

    ctx: CanvasRenderingContext2D;
    width: number;
    height: number;
    canvasStates : CanvasState[];
    showGrid : boolean = true;
    pinRadius : number = 20;
    canvasOptions: any;
    mapImage: HTMLImageElement = null;
    backgroundImage: HTMLImageElement = null;
    editedAction=null;
    //tmp
    points : Point[] = [];
    pins : HTMLDivElement[] = [];
    offset;
    imageOffset;

    constructor(
      public canvasState: CanvasStateService,
      public optionsService: OptionsService,
      public scaleService: ScaleService,      
      public canvasOptionsService: CanvasOptionsService,
      public elementsService: ElementsService,
      public dataService: DataService,
      private undoService: UndoService,
      private canvasStateService:CanvasStateService
     ) {        
      this.offset=SCALE.screen.offset;
      this.canvasOptions = CANVAS_OPTIONS;
      this.imageOffset=CANVAS_OPTIONS.imageOffset;
      this.setBasicActions(); 
    }

    ngOnInit() { 
      
      this.ctx=this.canvasRef.nativeElement.getContext('2d');      
      this.resize();


      this.subscription = this.optionsService.options$.subscribe(data => {
        let activeOption=this.optionsService.active;
          // this.canvasOptionsService.setActiveZone(activeOption.staticName,null)
        this.changeAction(activeOption?activeOption.staticName:null,activeOption?activeOption.active:false);
      });

      this.subscription = this.undoService.actionsList$.subscribe(data => {        
        
        if(data.state=='undo'){
          this.draw();
        }
      });

      this.subscription = this.canvasState.canvasState$.subscribe(data => {
        if(data.staticName=='drag' && data.active==true){
          this.canvasRef.nativeElement.style.cursor = "grab";
          this.stopActions();
          this.drag();
        }else if(data.staticName=='drag' && data.active==false){
          let activeZone=this.canvasOptionsService.getActiveZone();
          this.stopActions();
          if(activeZone.name=='ZONE-ROOF'){
            this.changeAction("ZONE-ROOF-EDIT",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='ZONE-ROOF-EDIT'){
            this.changeAction("ZONE-ROOF-EDIT",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='DRAW-CONTOUR'){
            this.changeAction("DRAW-CONTOUR",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else{            
            this.canvasRef.nativeElement.style.cursor = "default";
          }
        }else if(data.staticName=='dragImg' && data.active==true){
          this.canvasRef.nativeElement.style.cursor = "grab";
          this.stopActions();
          this.dragImg();
        }else if(data.staticName=='dragImg' && data.active==false){
          let activeZone=this.canvasOptionsService.getActiveZone();
          this.stopActions();
          if(activeZone.name=='ZONE-ROOF'){
            this.changeAction("ZONE-ROOF-EDIT",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='ZONE-ROOF-EDIT'){
            this.changeAction("ZONE-ROOF-EDIT",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='DRAW-CONTOUR'){
            this.changeAction("DRAW-CONTOUR",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else{            
            this.canvasRef.nativeElement.style.cursor = "default";
          }
        }else if(data.staticName=='draw' && data.active==true){
          this.canvasRef.nativeElement.style.cursor = "crosshair";
        }else if(data.staticName=='remove'  && data.active==true){ 
          let activeZone=this.canvasOptionsService.getActiveZone(); 
          if(activeZone.name=='ZONE-ROOF' || activeZone.name=='ZONE-ROOF-EDIT'){ 
            this.changeAction("ZONE-ROOF-REMOVE",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='DRAW-CONTOUR'){
            this.changeAction("DRAW-CONTOUR-REMOVE",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }
        }else if(data.staticName=='remove'  && data.active==false){ 
          let activeZone=this.canvasOptionsService.getActiveZone();
          this.stopActions();
          if(activeZone.name=='ZONE-ROOF'){
            this.changeAction("ZONE-ROOF-EDIT",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='ZONE-ROOF-EDIT'){
            this.changeAction("ZONE-ROOF-EDIT",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else if(activeZone.name=='DRAW-CONTOUR'){
            this.changeAction("DRAW-CONTOUR",true);
            this.canvasRef.nativeElement.style.cursor = "crosshair";
          }else{            
            this.canvasRef.nativeElement.style.cursor = "default";
          }
        }else if(data.staticName=='highlightZone' ){ 
          this.draw();
          this.highlight('zones',data.type)
        }else if(data.staticName=='highlightContour' ){ 
          this.draw();
          this.highlight('contour',1)
        }else{   
          this.stopActions();       
          this.canvasRef.nativeElement.style.cursor = "default";
        }

      });


      this.subscription = this.scaleService.scale$.subscribe(data => {
        this.offset=data.screen.offset;
        // this.imageOffset={left:this.imageOffset.left*data.screen.ratio,top:this.imageOffset.top*data.screen.ratio}
        this.draw();
      });

      this.subscription = this.elementsService.elements$.subscribe(data => {
        this.draw();
        
      });
      

      this.subscription = this.canvasOptionsService.canvasOptions$.subscribe(data => {
        this.canvasOptions = data;
        if(!this.setMapImage()){
          this.draw();
        }

        if(!this.setBackgroundImage()){
          this.draw();
        }

        if(data.activeZone.name=="ZONE-ROOF" || data.activeZone.name=="DRAW-CONTOUR" || data.activeZone.name=="ZONE-ROOF-EDIT"){
          this.canvasState.setState('draw',true);
        }else{
          this.canvasState.clearState();
        }
        if(data.activeZone.name=="ZONE-ROOF-EDIT" &&  data.activeZone.id!=null){ 
          // this.editedAction=data.activeZone ;                
          this.changeAction('ZONE-ROOF-EDIT',true);  
        }
        // this.editedAction=data.activeZone;
        
        
      });

    }

    drag(){
      if(this.detectmob()){
        $(this.canvasRef.nativeElement).bind('touchstart', this.dragtouch());
      }else{
        $(this.canvasRef.nativeElement).bind('mousedown', this.dragmouse());
      }       
    }

    dragtouch(){      
      let self=this;
      let funct= function(event){
        let x=event.targetTouches[0].pageX
        let y=event.targetTouches[0].pageY
        let startX=self.offset.left
        let startY=self.offset.top

        
        $(this).bind('touchmove', function(e){
            self.offset.left=startX+x-e.targetTouches[0].pageX
            self.offset.top=startY+y-e.targetTouches[0].pageY
            e.preventDefault();
            self.draw();
        })
        $(this).bind('touchend', function(event){
          $(this).unbind('touchend')
          $(this).unbind('touchmove')
        })
      }

      return funct;
    }

    dragmouse(){
      let self=this;
      let funct= function(event){
        let x=event.offsetX
        let y=event.offsetY
        let startX=self.offset.left
        let startY=self.offset.top

        self.canvasRef.nativeElement.classList.add('grabbing')
        let eventX=event.offsetX
        let eventY=event.offsetY
        $(this).bind('mousemove', function(e){
            self.offset.left=startX+eventX-e.offsetX
            self.offset.top=startY+eventY-e.offsetY
            e.preventDefault();
            self.draw();
        })
        $(this).bind('mouseup', function(event){
          self.canvasRef.nativeElement.classList.remove('grabbing')
          $(this).unbind('mouseup')
          $(this).unbind('mousemove')
        })
      }

      return funct;
    }


    dragImg(){
      if(this.detectmob()){
        $(this.canvasRef.nativeElement).bind('touchstart', this.dragtouchImg());
      }else{
        $(this.canvasRef.nativeElement).bind('mousedown', this.dragmouseImg());
      }       
    }

    dragtouchImg(){      
      let self=this;
      let funct= function(event){
        let x=event.targetTouches[0].pageX
        let y=event.targetTouches[0].pageY
        let startX=self.imageOffset.left
        let startY=self.imageOffset.top

        
        $(this).bind('touchmove', function(e){
            self.imageOffset.left=(startX+x-e.targetTouches[0].pageX)
            self.imageOffset.top=startY+y-e.targetTouches[0].pageY
            e.preventDefault();
            self.draw();
        })
        $(this).bind('touchend', function(event){
          $(this).unbind('touchend')
          $(this).unbind('touchmove')
        })
      }

      return funct;
    }

    dragmouseImg(){
      let self=this;
      let funct= function(event){
        let x=event.offsetX
        let y=event.offsetY
        let startX=self.imageOffset.left*SCALE.screen.ratio
        let startY=self.imageOffset.top*SCALE.screen.ratio
        self.canvasRef.nativeElement.classList.add('grabbing')

        
        $(this).bind('mousemove', function(e){
            self.imageOffset.left=(startX+event.offsetX-e.offsetX)/SCALE.screen.ratio
            self.imageOffset.top=(startY+event.offsetY-e.offsetY)/SCALE.screen.ratio

            e.preventDefault();
            self.draw();
        })
        $(this).bind('mouseup', function(event){
          self.canvasRef.nativeElement.classList.remove('grabbing')
          $(this).unbind('mouseip')
          $(this).unbind('mousemove')
        })
      }

      return funct;
    }



    resize(){
      
      this.width=this.canvasWrapper.nativeElement.offsetWidth;
      this.height=this.canvasWrapper.nativeElement.offsetHeight;
      this.canvasRef.nativeElement.setAttribute('width',this.width);
      this.canvasRef.nativeElement.setAttribute('height',this.height);
      this.draw();
            
    } 

    changeAction(action:string,active:boolean){
      
      this.stopActions();
      if(action && active){
        
        switch(action){
          case 'DRAW-CONTOUR': 
          let contourId:number=0;
            if(this.elementsService.getNumberOfElements('contour')==0){
              contourId=this.elementsService.addContour().id 
            }else{
              contourId=this.elementsService.getContourId();
            }
            
            this.canvasOptionsService.setActiveZone(action,contourId )
            let zones=this.elementsService.getZones();
            let zonesArray=[];
            for(let i=0; i<zones.length;i++){
                zonesArray.push(zones[i].points)
            }
            this.startDraw(this.elementsService.getContourPoints(),zonesArray)
          break;
          case 'DRAW-CONTOUR-REMOVE': 
            let contourPts=this.elementsService.getContourPoints();
            this.startRemove(contourPts)
          break;
          case 'ZONE-ROOF-ADD': 
            
          
            // if(ELEMENTS.zones.length==0){
            // }
            let id=this.elementsService.addZone()
            this.canvasOptionsService.setActiveZone('ZONE-ROOF',id)
 
            let points=[]
            if(this.elementsService.getNumberOfElements('contour')>0){
              points=this.elementsService.getContourPoints();   
            }
            zones=this.elementsService.getZones();
            zonesArray=[];
            for(let i=0; i<zones.length;i++){
              if(zones[i].id!=id)
                zonesArray.push(zones[i].points)
            }
            zonesArray.push(points)
            this.startDraw(this.elementsService.getZonePoints(id),zonesArray,points)
          break;

          case 'ZONE-ROOF-EDIT':
          
            points=[]
            if(this.elementsService.getNumberOfElements('contour')>0){
              points=this.elementsService.getContourPoints();   
            }
            let az=this.canvasOptionsService.getActiveZone()
            zones=this.elementsService.getZones();
            zonesArray=[];
            for(let i=0; i<zones.length;i++){
              if(zones[i].id!=id)
                zonesArray.push(zones[i].points)
            }
            zonesArray.push(points)
            this.startDraw(this.elementsService.getZonePoints(az.id),zonesArray,points)
          break; 

          case 'ZONE-ROOF-REMOVE': 
            let activeLayer=this.canvasOptionsService.getActiveZone();
            
            let zonesPts=this.elementsService.getElementById('zones',activeLayer.id);
            this.startRemove(zonesPts.points)
          break;

          case 'PROPERTIES': 
            this.canvasOptionsService.setActiveZone(null,null)
            this.clickOnLayer('highlight');
          
          break;
          case 'ZONE-ROOF': 
            this.canvasOptionsService.setActiveZone(null,null)
            this.clickOnLayer('select');
        
          break;
          default:
          this.canvasOptionsService.clearAction();
            this.stopActions();
            this.draw();
            
          break;
        }
      }else{
        switch(action){
          case 'ZONE-ROOF-ADD': 
            let deleted=this.elementsService.clearInvalidZones();
            this.canvasOptionsService.setActiveZone(action,null)            
            this.stopActions();
            this.clickOnLayer('select');
          break;
          default:
            this.stopActions();
            break;
        }
        // this.resize();
      }
    }

    stopActions(){   
      // this.canvasOptionsService.clearAction();
      $(this.canvasRef.nativeElement).unbind();  
      // this.setBasicActions(); 
    }

    setBasicActions(){
      let self=this;
      let putOnce=0;
      function doKeyDown(e) {
        if(e.keyCode==16){
          if(putOnce==0){
            self.canvasOptionsService.setAlign(false);   
            putOnce++;
          }          
          
        }else if(e.keyCode==32){  
          if(putOnce==0){
            self.canvasState.setState('drag',true);
            putOnce++;
          }          
        }else if(e.keyCode==17){
          if(putOnce==0){
            $(self.canvasRef.nativeElement).bind('mousewheel DOMMouseScroll', function(event){
              event.preventDefault()

              if((event.originalEvent.wheelDelta!=undefined && event.originalEvent.wheelDelta>0) || event.originalEvent.detail<0){                
                  self.scaleService.changeScale('+');
                
              }else if((event.originalEvent.wheelDelta!=undefined && event.originalEvent.wheelDelta<0) || event.originalEvent.detail>0){                
                  self.scaleService.changeScale('-');
              }
              return false;
            })
            putOnce++;
          }
        }
      }


      function doKeyUp(e) {
        if(e.keyCode==17 && !e.ctrlKey){
          e.preventDefault()
          putOnce=0;
          $(self.canvasRef.nativeElement).unbind('mousewheel')
          return false;
        }else if(e.keyCode==32){  
            putOnce=0;
            self.canvasState.setState('drag',false);    
        }else if(e.keyCode==16 && !e.shiftKey){
          self.canvasOptionsService.setAlign(true);
          putOnce=0;
        }
      }

      $(document).keydown(doKeyDown); 
      $(document).keyup(doKeyUp);      
    }

    validateZones(){
      let activeZone=this.canvasOptionsService.getActiveZone(); 
      let zone=null;
      if(activeZone.name=='DRAW-CONTOUR'){
        zone=this.elementsService.getElementById('contour',activeZone.id)
        if(zone.points.length>2 && zone.points[0].x==zone.points[zone.points.length-1].x && zone.points[0].y==zone.points[zone.points.length-1].y){
          //valid to enable next step
          this.optionsService.change('ZONE-ROOF','enabled',true)
        }else{
          //block next step
        }
      }else if(activeZone.name=='ZONE-ROOF'||activeZone.name=='ZONE-ROOF-EDIT'){
        zone=this.elementsService.getZoneById(activeZone.id)
        if(zone.points.length>2 && zone.points[0].x==zone.points[zone.points.length-1].x && zone.points[0].y==zone.points[zone.points.length-1].y){
          //valid to enable next step

        }else{
          //block next step
        }
      }
    }

    clickOnLayer(mode:string='highlight'){
      let self=this;
      $(this.canvasRef.nativeElement).click(function(event){ 
        let point : Point = {x:(parseInt(event.pageX)+self.offset.left)/SCALE.screen.ratio,y:(parseInt(event.pageY)+self.offset.top)/SCALE.screen.ratio}
        let zones = self.elementsService.getZones();
        for(let i=zones.length-1;i>=0;i--){
          if(self.isPointInside(point,zones[i].points)<=0){
            // console.warn('isInside')
            if(mode=='highlight')
              self.canvasStateService.setState('highlightZone',true,zones[i].id)
            else if(mode=='select')
              self.canvasOptionsService.setActiveZone('ZONE-ROOF',zones[i].id)
            break;
          }
        }
        // this.isPointInside(point)
      })
    }

    draw(){
      this.ctx.clearRect(0,0,this.width,this.height)

        
      if(this.canvasOptions.background==1 && this.canvasOptions.map.image)
        this.drawMap();
      else if(this.canvasOptions.background==2 && this.canvasOptions.image)
        this.drawBackgroundImage();

      if(this.canvasOptions.grid)
        this.drawGrid();

      this.drawContour();
      this.drawZones();

      this.drawActiveLayerOnTop()

      // this.validateZones()
    }

    highlight(type,id){
      let zone=this.elementsService.getElementById(type,id)
      if(zone)
        this.drawShape(zone.points,'#cdfe62',false);
    }

    drawActiveLayerOnTop(){
      let activeZone=this.canvasOptionsService.getActiveZone();  
      let zone=null;
      if(activeZone.name=='DRAW-CONTOUR'){
        zone=this.elementsService.getElementById('contour',activeZone.id)
        this.drawShape(zone.points,zone.color,false);
        this.drawLengthDimensionLine(zone.points,zone.color,false)
        this.drawPins(zone.points,zone.color);
        
      }else if(activeZone.name=='ZONE-ROOF'||activeZone.name=='ZONE-ROOF-EDIT'){
        zone=this.elementsService.getZoneById(activeZone.id)
        if(zone.points.length>0 && this.elementsService.comparePoints(zone.points[0],zone.points[zone.points.length-1]))
          this.drawShape(zone.points,zone.color,true); 
        else
          this.drawShape(zone.points,zone.color,false); 

        this.drawLengthDimensionLine(zone.points,zone.color,false)
        this.drawPins(zone.points,zone.color);
      }
    }

    drawContour(){
      let activeZone=this.canvasOptionsService.getActiveZone();  
      for(let i=0;i<this.elementsService.getNumberOfElements('contour');i++){       
        let zone=this.elementsService.getContour(i)   
        if(activeZone.name=='DRAW-CONTOUR' && activeZone.id==zone.id){
        }else{
          this.drawShape(zone.points,zone.color,false);
        }
      }
    }

    drawZones(){
      let activeZone=this.canvasOptionsService.getActiveZone();  
      for(let i=0;i<this.elementsService.getNumberOfElements('zones');i++){
        let zone=this.elementsService.getZone(i)   
        if((activeZone.name=='ZONE-ROOF'||activeZone.name=='ZONE-ROOF-EDIT') && activeZone.id==zone.id){
        }else{
          if(this.elementsService.checkIfShapeClosed(zone))
            this.drawShape(zone.points,zone.color,true);   
          else
            this.drawShape(zone.points,zone.color,false);   
        }
      }  
      
    }

    startRemove(points: Point[]){
      let self=this;
      let activeZone=this.canvasOptionsService.getActiveZone();
      $(this.canvasRef.nativeElement).click(function(event){
        let point : Point = {x:(parseInt(event.pageX)+self.offset.left)/SCALE.screen.ratio,y:(parseInt(event.pageY)+self.offset.top)/SCALE.screen.ratio}
        let clickedPoint : number[] = self.clickedPoint(point,points);
        
          let removedPoints=[]
          let highestId=null;
          let len=points.length;
          let originalPoints=points.slice();
        while(clickedPoint.length){
          if(highestId==null || highestId<clickedPoint[0])
            highestId=clickedPoint[0];

          removedPoints.push({index:clickedPoint[0],value:points[clickedPoint[0]]})
          points.splice(clickedPoint[0],1);
          clickedPoint = self.clickedPoint(point,points);
        }
        if(removedPoints.length){
          if(highestId!=len-1){
            points.pop();
          
            let refactoredArray=[];
            refactoredArray=points.splice(highestId,points.length-highestId)
            
            for(let i=refactoredArray.length-1;i>=0;i--){
              points.unshift(refactoredArray[i])
            }
          }
          self.undoService.addAction('removePoint',{type:activeZone.name,layer:activeZone.id,points:originalPoints})
        }
        
        self.draw();
      })
    }

    startDraw(points: Point[], additionalAlignPoints=[], border=null){      
      let self = this;
      let additionalPoints : Point[] = points;
      
      let mousedown=this.mouseDown(points,additionalAlignPoints,border)
      let touchstart=this.touchstart(points,additionalAlignPoints,border)
      
      if(this.detectmob()){
        $(this.canvasRef.nativeElement).bind('touchstart', touchstart);
      }else{
        $(this.canvasRef.nativeElement).bind('mousedown', mousedown);
    }

      $(this.canvasRef.nativeElement).dblclick(function(event){
        let point : Point = {x:(parseInt(event.pageX)+self.offset.left)/SCALE.screen.ratio,y:(parseInt(event.pageY)+self.offset.top)/SCALE.screen.ratio}
          let clickedPoint : number[] = self.clickedPoint(point,points);
          let pointId : number;

          if(points.length>1 && points[0].x==points[points.length-1].x && points[0].y==points[points.length-1].y){
            return false;
          }
          
          if(clickedPoint.length==0){
          }else{
            if(self.canvasOptions.align){
              for(let i=0;i<additionalAlignPoints.length;i++){
                additionalPoints=additionalPoints.concat(additionalAlignPoints[i])
              }
              point=self.alignPoint(point, additionalPoints, pointId)
            }
            // for(let i = 0; i<clickedPoint.length;+++){
              pointId=self.addPoint(point, points);
              
              let activeZone=self.canvasOptionsService.getActiveZone();
              self.undoService.addAction('addPoint',{type:activeZone.name,layer:activeZone.id,id:pointId})
  
            // }
            self.draw();
          }
      });
    }

    touchstart(points,additionalAlignPoints,border=null){
      let self=this;


      let touchstart=function(event){
          if(event.type=='mousedown' && event.button!=0)
            return false;

          let additionalPoints : Point[] = [];
          let targetX=parseInt(event.targetTouches[0].pageX);
          let targetY=parseInt(event.targetTouches[0].pageY);
          
          for(let i=0;i<additionalAlignPoints.length;i++){
            additionalPoints=additionalPoints.concat(additionalAlignPoints[i])
          }

          let point : Point = {x:(targetX+self.offset.left)/SCALE.screen.ratio,y:(targetY+self.offset.top)/SCALE.screen.ratio}
          let clickedPoint : number[] = self.clickedPoints(point,points);
          let clickedOtherPoint = self.clickedOtherPoints(point,additionalAlignPoints);
          let pointId : number;
          let startingPoint=null;

          if(clickedPoint.length==0){
            if(points.length>1 && points[0].x==points[points.length-1].x && points[0].y==points[points.length-1].y){
              // return false;
            }else if(border && self.isPointInside(point,border)>0){
              return false;
            }
            let newIndex=self.checkIfOnLine(point.x, point.y, points)
            
            if(newIndex)
              pointId=self.addPoint(point, points,newIndex.j);  
            else
              pointId=self.addPoint(point, points);
            
            if(self.canvasOptions.align){     
              let point2=self.alignPoint(point, additionalPoints, pointId)  
              if(!border || (border && self.isPointInside(point2,border)<1)){ 
                point=point2;
              }            
              self.movePoint(point, points, pointId);
            }

            let activeZone=self.canvasOptionsService.getActiveZone();
            self.undoService.addAction('addPoint',{type:activeZone.name,layer:activeZone.id,id:pointId})

            self.draw();
          }else{
            startingPoint={x:points[clickedPoint[0]].x,y:points[clickedPoint[0]].y}

            let activeZone=self.canvasOptionsService.getActiveZone();
            self.undoService.addAction('movePoint',{type:activeZone.name,layer:activeZone.id,originalPosition:startingPoint,id:clickedPoint,otherPoints:clickedOtherPoint,otherPointsArray:additionalAlignPoints})
        
          }
          
          additionalPoints=points.concat(additionalPoints)

          $(this).bind('touchmove', function(e){
            let targetX,targetY;        
            targetX=parseInt(e.targetTouches[0].pageX);
            targetY=parseInt(e.targetTouches[0].pageY);

            let point : Point = {x:(targetX+self.offset.left)/SCALE.screen.ratio,y:(targetY+self.offset.top)/SCALE.screen.ratio}
            
            if(clickedPoint.length>0){
              for(let i = 0; i<clickedPoint.length;i++){

                if(!border || (border && self.isPointInside(point,border)<1)){                
                  if(self.canvasOptions.align){                       
                    let point2=self.alignPoint(point, additionalPoints, clickedPoint, startingPoint)
                    if(!border || (border && self.isPointInside(point2,border)<1)){ 
                      point=point2;
                    }   
                  }
                  self.movePoint(point, points, clickedPoint[i]);   
                }
              }
              if(!border){
                if(clickedOtherPoint.length>0){
                  for(let i=0;i<clickedOtherPoint.length;i++){
                      self.movePoint(point, additionalAlignPoints[clickedOtherPoint[i].zone], clickedOtherPoint[i].id); 
                  }
                }
              }
            }else{  
              if(!border || (border && self.isPointInside(point,border)<1)){                
                if(self.canvasOptions.align){     
                  let point2=self.alignPoint(point, additionalPoints, pointId)
                  if(!border || (border && self.isPointInside(point2,border)<1)){ 
                    point=point2;
                  } 
                }
                self.movePoint(point, points, pointId);
              }
            }
            self.draw();
          });

          $(this).bind('touchend', function(e){  
            $(this).unbind('touchmove');             
            $(this).unbind('touchend');  
            self.draw();

          });
        };
        return touchstart;  
    }

    mouseDown(points,additionalAlignPoints,border=null){
        let self=this;


        let mousedown=function(event){
          if(event.type=='mousedown' && event.button!=0)
            return false;

          let additionalPoints : Point[] = [];
          let targetX=parseInt(event.pageX);
          let targetY=parseInt(event.pageY);
          
          for(let i=0;i<additionalAlignPoints.length;i++){
            additionalPoints=additionalPoints.concat(additionalAlignPoints[i])
          }

          let point : Point = {x:(targetX+self.offset.left)/SCALE.screen.ratio,y:(targetY+self.offset.top)/SCALE.screen.ratio}
          let clickedPoint : number[] = self.clickedPoints(point,points);
          let clickedOtherPoint = self.clickedOtherPoints(point,additionalAlignPoints);
          let pointId : number;
          let startingPoint=null;

          if(clickedPoint.length==0){
            if(points.length>1 && points[0].x==points[points.length-1].x && points[0].y==points[points.length-1].y){
              // return false;
            }else if(border && self.isPointInside(point,border)>0){
              return false;
            }
            let newIndex=self.checkIfOnLine(point.x, point.y, points)

            if(newIndex)
              pointId=self.addPoint(point, points,newIndex.j);  
            else
              pointId=self.addPoint(point, points);

            if(self.canvasOptions.align){     
              let point2=self.alignPoint(point, additionalPoints, pointId)  
              if(!border || (border && self.isPointInside(point2,border)<1)){ 
                point=point2;
              }           
              self.movePoint(point, points, pointId);
            }
            
            let activeZone=self.canvasOptionsService.getActiveZone();
            self.undoService.addAction('addPoint',{type:activeZone.name,layer:activeZone.id,id:pointId})

            self.draw();
          }else{
            startingPoint={x:points[clickedPoint[0]].x,y:points[clickedPoint[0]].y}

            let activeZone=self.canvasOptionsService.getActiveZone();
            self.undoService.addAction('movePoint',{type:activeZone.name,layer:activeZone.id,originalPosition:startingPoint,id:clickedPoint,otherPoints:clickedOtherPoint,otherPointsArray:additionalAlignPoints})
            
          }

          additionalPoints=points.concat(additionalPoints)
          $(this).bind('mousemove', function(e){
            let targetX,targetY;            
            targetX=parseInt(e.pageX);
            targetY=parseInt(e.pageY);

            let point : Point = {x:(targetX+self.offset.left)/SCALE.screen.ratio,y:(targetY+self.offset.top)/SCALE.screen.ratio}
            
            if(clickedPoint.length>0){
              for(let i = 0; i<clickedPoint.length;i++){
                // additionalPoints=points.concat(additionalPoints)
                if(!border || (border && self.isPointInside(point,border)<1)){ 
                  if(self.canvasOptions.align){                       
                    let point2=self.alignPoint(point, additionalPoints, clickedPoint, startingPoint)
                    if(!border || (border && self.isPointInside(point2,border)<1)){ 
                      point=point2;
                    }     
                               
                  }
                  self.movePoint(point, points, clickedPoint[i]);   
                }
              }
              if(!border){
                if(clickedOtherPoint.length>0){
                  for(let i=0;i<clickedOtherPoint.length;i++){
                      self.movePoint(point, additionalAlignPoints[clickedOtherPoint[i].zone], clickedOtherPoint[i].id); 
                  }
                }
              }
            }else{                
              if(!border || (border && self.isPointInside(point,border)<1)){ 
                if(self.canvasOptions.align){     
                  let point2=self.alignPoint(point, additionalPoints, pointId)
                  if(!border || (border && self.isPointInside(point2,border)<1)){ 
                    point=point2;
                  } 
                }
                self.movePoint(point, points, pointId);                  
                }
            }
            self.draw();
          });

          $(this).bind('mouseup', function(e){
            $(this).unbind('mousemove');             
            $(this).unbind('mouseup'); 
            self.draw();
            
          });
        };
        return mousedown;
    }

    checkIfOnLine(x, y, points) {
      if (points.length > 1) {
          let minDist = null;
          let a, b;
          let minIndex = null
          for (let i = 0; i < points.length; i++) {

              if (i < points.length - 1) {
                  a = i;
                  b = i + 1;
              } else {
                  a = i;
                  b = 0;
              }

              let point1 = points[a];
              let point2 = points[b];


              let dist = this.pDistance(x, y, point1.x, point1.y, point2.x, point2.y);
              let margin = 20 //data.o.scaleView < 1 ? 10 : 10 / data.o.scaleView;

              if (dist < margin) {

                  if (!minDist) {
                      minDist = dist;
                      minIndex = {
                          i: a,
                          j: b
                      };
                  } else if (minDist > dist) {
                      minDist = dist;
                      minIndex = {
                          i: a,
                          j: b
                      };
                  }
              } else {
              }

          }
          return minIndex;
      }
  }

  //--------------------------------------------------------------------------
    //  odleglosc punktu @x@y od odcinka @x1@y1-@x2-@y2
    //--------------------------------------------------------------------------
    pDistance(x, y, x1, y1, x2, y2) {

      let A = x - x1;
      let B = y - y1;
      let C = x2 - x1;
      let D = y2 - y1;

      let dot = A * C + B * D;
      let len_sq = C * C + D * D;
      let param = -1;
      if (len_sq != 0) //in case of 0 length line
          param = dot / len_sq;

      let xx, yy;

      if (param < 0) {
          xx = x1;
          yy = y1;
      } else if (param > 1) {
          xx = x2;
          yy = y2;
      } else {
          xx = x1 + param * C;
          yy = y1 + param * D;
      }

      let dx = x - xx;
      let dy = y - yy;

      return Math.sqrt(dx * dx + dy * dy);
  }
  //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    //  Sprawdza czy punkt @point {x:,y:} jest w obszarze layer [{x:,y:},(...)]
    //--------------------------------------------------------------------------
    isPointInside(point, layer) {
      let pt=[point.x,point.y];
      let polygon=[]
      for(let i=0;i<layer.length;i++){
        polygon.push([layer[i].x,layer[i].y])
        if(point.x==layer[i].x && point.y==layer[i].y)
          return 0;
      }

      let classifyPoint = require("robust-point-in-polygon")
      // var polygon = [ [ 1, 1 ], [ 1, 2 ], [ 2, 2 ], [ 2, 1 ] ]
      return classifyPoint(polygon, pt);
      // console.log(
      //   classifyPoint(polygon, [1.5, 1.5]),
      //   classifyPoint(polygon, [1, 2]),
      //   classifyPoint(polygon, [100000, 10000]))
    }
    isPointInside2(point, layer) {
      let x = point.x,
          y = point.y;
      let inside = false;
      for (let i = 0, j = layer.length - 1; i < layer.length; j = i++) {
          let xi = layer[i].x,
              yi = layer[i].y;
          let xj = layer[j].x,
              yj = layer[j].y;

          let intersect = ((yi >= y) != (yj >= y)) &&
              (x <= (xj - xi) * (y - yi) / (yj - yi) + xi);
          if (intersect) inside = !inside;
      }
      if (inside) {}
      return inside;
    };
    //--------------------------------------------------------------------------

    clickedOtherPoints(point,points){
      let radius = (this.pinRadius+3)/SCALE.screen.ratio;
      let foundPoints = [];
      if(points!=undefined)
        for(let i=0;i<points.length;i++){
          if(points[i]!=undefined)
            for(let j=0;j<points[i].length;j++){
              if(point.x < points[i][j].x + radius && point.x > points[i][j].x - radius &&
                point.y < points[i][j].y + radius && point.y > points[i][j].y - radius){
                  foundPoints.push({zone:i,id:j});
                }
            }
        }
      return foundPoints;
    }

    clickedPoints(point,points){
      let radius = (this.pinRadius+3)/SCALE.screen.ratio;
      let foundPoints : number[] = [];
      for(let i=0;i<points.length;i++){
        if(point.x < points[i].x + radius && point.x > points[i].x - radius &&
          point.y < points[i].y + radius && point.y > points[i].y - radius){
            foundPoints.push(i)
            
          }
      }
      return foundPoints;
    }

    clickedPoint(point,points){

      let radius = (this.pinRadius+3)/SCALE.screen.ratio;
      let foundPoints : number[] = [];
      for(let i=points.length-1;i>=0;i--){
        if(point.x < points[i].x + radius && point.x > points[i].x - radius &&
          point.y < points[i].y + radius && point.y > points[i].y - radius){
            
            foundPoints.push(i)
            break;         
          }
      }
      return foundPoints;
    }

    movePoint(point, points, pointId){
      points[pointId]=point;

      return pointId
    }

    addPoint(point, points,index=null){
      let ptId:number;
      if(!index){
        points.push(point);
        ptId=points.length-1;
      }else{
        points.splice(index, 0, point);        
        ptId=index
      }
      
      return ptId;
    }

    alignPoint(point, points, clickedPoints, startingPoint=null){
      if(points.length==1)
        return point;

      // console.log(points)
      let radius = (this.pinRadius+3)/SCALE.screen.ratio;
      let pointsId  =[];
      let pointId = null;
      // console.warn(clickedPoints)
      if(isArray(clickedPoints)){
        pointsId=clickedPoints;
      }else{
        pointId=clickedPoints;
      }
      // console.warn('###########  align  #########')
      // console.log(points)
      let alignedPoint : Point = {x:point.x,y:point.y};
      let closestPoint:Point={x:point.x,y:point.y};
      let xDiff=null;
      let yDiff=null;
      let minDistance:number=null;
      for(let i=points.length-1;i>=0;i--){
      // for(let i=0;i<points.length;i++){
        if(pointId==i)
          continue;
        if(pointsId.indexOf(i)>=0)        
          continue;
          
        if(startingPoint && points[i].x==startingPoint.x && points[i].y==startingPoint.y ){
          continue;
        }else{
        }

        let dxDiff=Math.abs(points[i].x-point.x);
        if(dxDiff<radius && (!xDiff || dxDiff<xDiff)){
          xDiff=dxDiff
          alignedPoint.x=points[i].x;
        }

        let dyDiff=Math.abs(points[i].y-point.y);
        if(dyDiff<radius && (!yDiff || dyDiff<yDiff)){
          yDiff=dyDiff
          alignedPoint.y=points[i].y;
        }

        // ponizsze rownalo tylko do najblizszego punktu
        // let lenX=alignedPoint.x-points[i].x;
        // let lenY=alignedPoint.y-points[i].y;  

        // let length : number = Math.sqrt(lenX*lenX+lenY*lenY);
        // console.log(i+'-'+length)
        // if(minDistance==null || length<minDistance){
        //   minDistance=length;
        //   closestPoint.x=alignedPoint.x
        //   closestPoint.y=alignedPoint.y
          // console.log(closestPoint)
        // }
         

      }
      // console.warn('###########  //align  #########')
      return alignedPoint;
      // return closestPoint;
    }

    setBackgroundImage(){
      if(this.canvasOptions.image && this.canvasOptions.background==2 && (!this.backgroundImage || this.backgroundImage.src!=this.canvasOptions.image)){
        
        let  self=this;
        this.backgroundImage= new Image;        
        this.backgroundImage.onload=function(){
          
          let newSize=self.calculateSize({width:self.backgroundImage.width,height:self.backgroundImage.height},{width:self.width,height:self.height})
          let newMetresPerPx=self.canvasOptions.imageMetersPerPx/(newSize.width/self.backgroundImage.width)
        self.scaleService.setMetersPerPx(newMetresPerPx);
        }
        this.backgroundImage.src=this.canvasOptions.image;
        return true;
      }
      return false;
    }


    setMapImage(){
      if(this.canvasOptions.map && this.canvasOptions.background==1 && (!this.mapImage || this.mapImage.src!=this.canvasOptions.map.image)){
        
        let  self=this;
        this.mapImage= new Image;        
        this.mapImage.onload=function(){
          
          let newSize=self.calculateSize({width:self.mapImage.width,height:self.mapImage.height},{width:self.width,height:self.height})
          let newMetresPerPx=self.canvasOptions.map.metersPerPx/(newSize.width/self.mapImage.width)
          
        self.scaleService.setMetersPerPx(newMetresPerPx);
        }
        this.mapImage.src=this.canvasOptions.map.image;
        return true;
      }
      return false;
    }

    drawBackgroundImage(){
      let resizeImgRatio=this.canvasOptions.imageMetersPerPx/SCALE.screen.metersPerPx
      if(this.backgroundImage)
      this.drawImage(this.backgroundImage,resizeImgRatio)
      // console.log(this.canvasOptions.imageOffset)
      // console.log(SCALE)
    }

    drawMap(){
      let resizeImgRatio=this.canvasOptions.map.metersPerPx/SCALE.screen.metersPerPx
        this.drawImage(this.mapImage,resizeImgRatio)
    }

    drawImage(image,resizeImgRatio){
      this.ctx.globalCompositeOperation='destination-over';
      // console.log(this.imageOffset)
      // console.log(this.offset)
      this.ctx.drawImage(image,0-this.imageOffset.left*SCALE.screen.ratio-this.offset.left,0-this.imageOffset.top*SCALE.screen.ratio-this.offset.top,resizeImgRatio*image.width,resizeImgRatio*image.height);
      this.ctx.globalCompositeOperation='source-over';
    }

    calculateSize(orgSize, targetSize){
      let newSize={width:targetSize.width,height:targetSize.height}

      let scale=targetSize.width/orgSize.width<targetSize.height/orgSize.height?targetSize.width/orgSize.width:targetSize.height/orgSize.height;
      newSize.width=orgSize.width*scale;
      newSize.height=orgSize.height*scale;
      
      return newSize;
    }

    drawGrid(){
      
      let processedSizes=this.scaleService.getProcessedSizes();

      this.ctx.lineWidth = 0.2;
      let counterX
      let counter
      let density : number = (processedSizes.pixels/4);
      if(this.offset.left<0){
        counter  = 4-Math.floor(-this.offset.left%(5*density)/density)
        counterX = -this.offset.left%density;
      }else{
        counter  = Math.floor(this.offset.left%(5*density)/density)
        counterX = density- this.offset.left%density;
      
      }
      while(counterX<this.canvasRef.nativeElement.offsetWidth){
        this.ctx.beginPath();
        this.ctx.moveTo(counterX, 0);
        this.ctx.lineTo(counterX, this.canvasRef.nativeElement.offsetHeight);
        
        counterX+=density;

        if(counter%5){  
          this.ctx.lineWidth = 0.2;
        }else{        
          counter = 0;
          this.ctx.lineWidth = 1;
        }
        counter++;
        this.ctx.strokeStyle = '#383838';
        this.ctx.stroke();
        this.ctx.closePath();
      }

      
      let counterY: number
      if(this.offset.top<0){
        counter  = 4-Math.floor(-this.offset.top%(5*density)/density)
        counterY = -this.offset.top%density;
      }else{
        counter  = Math.floor(this.offset.top%(5*density)/density)
        counterY = density- this.offset.top%density;
      
      }
      while(counterY<this.canvasRef.nativeElement.offsetHeight){
        this.ctx.beginPath();
        this.ctx.moveTo(0, counterY);
        this.ctx.lineTo(this.canvasRef.nativeElement.offsetWidth, counterY);
        
        counterY+=density;

        if(counter%5){   
          this.ctx.lineWidth = 0.2;
        }else{       
          counter = 0;
          this.ctx.lineWidth = 1;
        }
        counter++;
        this.ctx.strokeStyle = '#383838';
        this.ctx.stroke();
        this.ctx.closePath();
      }

    }

    drawPins(points : Point[], color: string){
      
      for(let i=0;i<points.length;i++){        
        this.ctx.beginPath(); 
        this.ctx.arc((points[i].x)*SCALE.screen.ratio-this.offset.left, (points[i].y)*SCALE.screen.ratio-this.offset.top, this.pinRadius, 0, 2 * Math.PI);
        

        this.ctx.moveTo((points[i].x)*SCALE.screen.ratio-this.offset.left-this.pinRadius, (points[i].y)*SCALE.screen.ratio-this.offset.top);
        this.ctx.lineTo((points[i].x)*SCALE.screen.ratio-this.offset.left+this.pinRadius, (points[i].y)*SCALE.screen.ratio-this.offset.top);

        this.ctx.moveTo((points[i].x)*SCALE.screen.ratio-this.offset.left, (points[i].y)*SCALE.screen.ratio-this.offset.top-this.pinRadius);
        this.ctx.lineTo((points[i].x)*SCALE.screen.ratio-this.offset.left, (points[i].y)*SCALE.screen.ratio-this.offset.top+this.pinRadius);
        
        if(points.length-1==i){
          this.ctx.strokeStyle = 'lightgreen';
          this.ctx.lineWidth = 2;
        }else{
          this.ctx.strokeStyle = '#383838';
          this.ctx.lineWidth = 1;
        }
        this.ctx.stroke();
        // this.ctx.fillStyle = color;
        // this.ctx.fill();
        this.ctx.closePath();

        
      }
    }


    drawShape(points : Point[], color: string, fill: boolean = false, lineWidth:number = 2,closeShape:boolean=false){

      if(points.length<1)
        return false;
      
      // if(fill)
        this.ctx.beginPath();

      for(let i=0;i<points.length;i++){
        if(i==0)
          this.ctx.moveTo((points[i].x)*SCALE.screen.ratio-this.offset.left, (points[i].y)*SCALE.screen.ratio-this.offset.top);
        else
          this.ctx.lineTo((points[i].x)*SCALE.screen.ratio-this.offset.left, (points[i].y)*SCALE.screen.ratio-this.offset.top);

      }
      this.ctx.strokeStyle = color;   
      this.ctx.fillStyle = color;   
      this.ctx.lineWidth = lineWidth;
      // if(points[0].x==points[points.length-1].x && points[0].y==points[points.length-1].y && fill){
        
      //   this.ctx.fill();
      //   this.ctx.closePath();
      // }else if(points[0].x==points[points.length-1].x && points[0].y==points[points.length-1].y && !fill){
      //   this.ctx.lineWidth = 4;
      //   this.ctx.stroke();
      // }else{
      // this.ctx.closePath();
      this.ctx.lineWidth = 2;
      this.ctx.stroke();
      // }

      if(fill){
        this.ctx.fill();
      }

    }

    drawLengthDimensionLine(points : Point[], color:string, closedShape: boolean){
      let offset = 40;
      if(points.length>1)
        for(let i=0;i<points.length;i++){
          
          this.ctx.beginPath();
          let lenX :number, lenY:number;
          let x1 :number, y1:number, x2 :number, y2:number;
          let px1 :number, py1:number, px2 :number, py2:number;

          x1=Math.round((points[i].x)*SCALE.screen.ratio-this.offset.left);
          y1=Math.round((points[i].y)*SCALE.screen.ratio-this.offset.top);
          px1=Math.round(points[i].x);
          py1=Math.round(points[i].y);

          if(i==points.length-1){
            if(closedShape){
              x2=Math.round((points[0].x)*SCALE.screen.ratio-this.offset.left);
              y2=Math.round((points[0].y)*SCALE.screen.ratio-this.offset.top);
              px2=Math.round(points[0].x);
              py2=Math.round(points[0].y);  
            }else{
              continue;
            }
          }else{
            x2=Math.round((points[i+1].x)*SCALE.screen.ratio-this.offset.left);
            y2=Math.round((points[i+1].y)*SCALE.screen.ratio-this.offset.top);
            px2=Math.round(points[i+1].x);
            py2=Math.round(points[i+1].y);  
          }      
          lenX=(px2-px1)*SCALE.screen.ratio;
          lenY=(py2-py1)*SCALE.screen.ratio;  

          let length : string = (Math.sqrt(lenX*lenX+lenY*lenY)*SCALE.screen.metersPerPx).toFixed(3);
          // let length = Math.round((Math.sqrt(lenX*lenX+lenY*lenY)*SCALE.screen.metersPerPx)*100)/100;

          let edgeABa = (y1 - y2) / (x1 - x2);          
          let edgeABb = y1 - edgeABa * x1; 
          
          let edgeXYa=-1/edgeABa;
          let edgeKLb=edgeABb + offset*Math.sqrt(1+edgeABa*edgeABa);
          let edgeAKb=y1 - edgeXYa * x1
          let edgeBLb=y2 - edgeXYa * x2
          let ptK:any={}
          let ptL:any={}
          
          let ptM:any={}
          let ptN:any={}
          if(edgeXYa == Infinity || edgeXYa == -Infinity){            
            ptK.x=x1
            ptK.y=y1+offset
            ptL.x=x2
            ptL.y=y2+offset
          }else if(edgeABa == Infinity || edgeABa == -Infinity){                        
            ptK.x=x1+offset
            ptK.y=y1
            ptL.x=x2+offset
            ptL.y=y2
          }else{
            ptK.x=(edgeAKb-edgeKLb)/(edgeABa-edgeXYa)
            ptK.y=edgeABa*ptK.x+edgeKLb;
            ptL.x=(edgeBLb-edgeKLb)/(edgeABa-edgeXYa)
            ptL.y=edgeABa*ptL.x+edgeKLb;
          }

          ptM.x=(10*x1+30*ptK.x)/(30+10)
          ptM.y=(10*y1+30*ptK.y)/(30+10)
          ptN.x=(10*x2+30*ptL.x)/(30+10)
          ptN.y=(10*y2+30*ptL.y)/(30+10)

          this.ctx.moveTo(ptM.x, ptM.y);
          this.ctx.lineTo(ptN.x, ptN.y);

          this.ctx.moveTo(x2, y2);
          this.ctx.lineTo(ptL.x, ptL.y);

          this.ctx.moveTo(x1, y1);
          this.ctx.lineTo(ptK.x, ptK.y);

          this.ctx.strokeStyle='#383838';
          this.ctx.lineWidth=1;
          this.ctx.stroke();
          // let length : number = Math.round(Math.sqrt(lenX*lenX+lenY*lenY)/SCALE.screen.pixels*SCALE.screen.meters*100);
          // length = length.toFixed(1);
          let width = this.ctx.measureText(length).width;
          let height = 16;
          this.ctx.font = height+"px Arial";
          this.ctx.fillStyle='#383838';
          
          this.ctx.fillText(length+'m', ptK.x+lenX/2-width/2, ptK.y+lenY/2+height/2);
          this.ctx.closePath();
        }
    
    }

    drawLengthLabels(points : Point[], color:string, closedShape: boolean){
      if(points.length>1)
        for(let i=0;i<points.length;i++){
          
          this.ctx.beginPath();
          let lenX :number, lenY:number;
          let x1 :number, y1:number, x2 :number, y2:number;
          
          x1=points[i].x*SCALE.screen.ratio;
          y1=points[i].y*SCALE.screen.ratio;
          if(i==points.length-1){
            if(closedShape)          {
              x2=points[0].x*SCALE.screen.ratio;
              y2=points[0].y*SCALE.screen.ratio;  
            }else{
              continue;
            }
          }else{
            x2=points[i+1].x*SCALE.screen.ratio
            y2=points[i+1].y*SCALE.screen.ratio
          }        
          lenX=x2-x1;
          lenY=y2-y1;  

          let length : number = Math.round(Math.sqrt(lenX*lenX+lenY*lenY)*SCALE.screen.metersPerPx*100);
          // let length : number = Math.round(Math.sqrt(lenX*lenX+lenY*lenY)/SCALE.screen.pixels*SCALE.screen.meters*100);
          // length = length.toFixed(1);
          let width = this.ctx.measureText(length.toString()).width;
          let height = 16;
          let paddingTop : number = 10;
          let paddingLeft : number = 20;
          this.ctx.fillStyle=color;
          this.ctx.fillRect(
            x1+lenX/2-width/2-paddingLeft,
            y1+lenY/2-height/2-paddingTop+3,
            width+2*paddingLeft,
            height+2*paddingTop);
          this.ctx.font = height+"px Arial";
          this.ctx.fillStyle='#383838';
          
          this.ctx.fillText(length.toString(), x1+lenX/2-width/2, y1+lenY/2+height/2);
          this.ctx.closePath();
        }
    }

    detectmob() { 
      if( navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
      ){
         return true;
       }
      else {
         return false;
       }
     }
}
